export const handleChange = (setFunction, boolean = false) => (e) => {
    if (boolean) {
        const value = e.target.value;
        const booleanValue = value === 'true';
        setFunction(prevState => ({
            ...prevState,
            [e.target.name]: booleanValue
        }));
    } else {
        setFunction(prevData => ({...prevData, [e.target.name]: e.target.value}));
    }
}

export const dateToInputString = (date) => {
    if (date) {
        return date.toISOString().split('T')[0];
    }
    return '';
}

export function sinValidation(value) {
    console.log("SIN!");

    // trim whitespace
    value = value.replace(/\s/g, "");

    // if not a number
    if (isNaN(value)) {
        return "";
    }

    // if value is not 9 characters long, return an error message
    if (value.length !== 9) {
        return "";
    }

    const validSin = (sin) => {

        if (sin.length === 9) {
            // convert to an array & pop off the check digit
            sin = sin.split('');
            let check = +sin.pop();

            let even = sin
                // take the digits at the even indices
                .filter(function (_, i) {
                    return i % 2;
                })
                // multiply them by two
                .map(function (n) {
                    return n * 2;
                })
                // and split them into individual digits
                .join('').split('');

            let tot = sin
                // take the digits at the odd indices
                .filter(function (_, i) {
                    return !(i % 2);
                })
                // concatenate them with the transformed numbers above
                .concat(even)
                // it's currently an array of strings; we want numbers
                .map(function (n) {
                    return +n;
                })
                // and take the sum
                .reduce(function (acc, cur) {
                    return acc + cur;
                });

            // compare the result against the check digit
            return check === (10 - (tot % 10)) % 10;
        }
    }

    if (validSin(value)) {
        return value;
    }

    return "";
}